import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import MainTopBar from '@/components/common/bar/MainTopBar'
import WideButton from '@/components/common/button/WideButton'
import qbeeImage from '@/assets/images/qbee-character/qbee-happy-transparent.png'

const hasPreviousTestResponse = false

export default function TypeTestMainPage() {
  const navigate = useNavigate()
  const [currentStep, setCurrentStep] = useState(1)

  useEffect(() => {
    if (currentStep === 1) {
      const timer = setTimeout(() => {
        setCurrentStep(2)
      }, 2000)
      return () => clearTimeout(timer)
    } else if (currentStep === 2) {
      const timer = setTimeout(() => {
        setCurrentStep(3)
      }, 2000)
      return () => clearTimeout(timer)
    }
  }, [currentStep])

  const handleStartTest = () => {
    navigate('/type-test/questions', { replace: true })
  }

  // 첫 번째 스플래시 화면
  if (currentStep === 1) {
    return (
      <div className='min-h-screen  flex items-center justify-center relative overflow-hidden'>
        {/* 배경 장식 요소들 */}
        <div className='absolute top-20 left-10 w-16 h-16 bg-white/20 rounded-full animate-pulse'></div>
        <div className='absolute top-40 right-16 w-12 h-12 bg-white/15 rounded-full animate-pulse delay-300'></div>
        <div className='absolute bottom-32 left-20 w-20 h-20 bg-white/10 rounded-full animate-pulse delay-500'></div>
        <div className='absolute bottom-20 right-10 w-14 h-14 bg-white/20 rounded-full animate-pulse delay-700'></div>

        {/* 메인 콘텐츠 */}
        <div className='text-center z-10 px-8'>
          <div className='bg-white/90 backdrop-blur-sm rounded-3xl p-8 shadow-xl border border-white/30 w-[70vw] h-[300px] flex flex-col justify-center items-center'>
            <div className='text-6xl mb-4 animate-bounce'>
              <img src={qbeeImage} alt='main-character' className=' w-20 h-20' />
            </div>
            <h1 className='text-amber-900 text-[18px] font-bold leading-relaxed text-nowrap'>
              안녕! 함께 나아가기 전
              <br />
              너에 대해서 궁금한 것들이
              <br />
              아주아주 가득해.
            </h1>
          </div>
        </div>
      </div>
    )
  }

  // 두 번째 스플래시 화면
  if (currentStep === 2) {
    return (
      <div className='min-h-screen  flex items-center justify-center relative overflow-hidden'>
        {/* 배경 장식 요소들 */}
        <div className='absolute top-16 left-8 w-24 h-24 bg-white/20 rounded-full animate-pulse'></div>
        <div className='absolute top-32 right-12 w-16 h-16 bg-white/15 rounded-full animate-pulse delay-200'></div>
        <div className='absolute bottom-40 left-16 w-20 h-20 bg-white/10 rounded-full animate-pulse delay-400'></div>
        <div className='absolute bottom-24 right-8 w-18 h-18 bg-white/20 rounded-full animate-pulse delay-600'></div>

        {/* 메인 콘텐츠 */}
        <div className='text-center z-10 px-8'>
          <div className='bg-white/90 backdrop-blur-sm rounded-3xl p-8 shadow-xl border border-white/30 w-[70vw] h-[300px] flex flex-col justify-center items-center'>
            <div className='flex justify-center mb-6'>
              <div className='relative'>
                <div className='text-4xl animate-spin-slow'>📋</div>
                <div className='absolute -top-2 -right-2 text-2xl animate-bounce delay-300'>✨</div>
              </div>
            </div>
            <h1 className='text-amber-900 text-[18px] font-bold leading-relaxed text-nowrap'>
              오직 너만을 위한
              <br />
              상담 커리큘럼을 위해
              <br />
              테스트를 준비했어.
            </h1>
          </div>
        </div>
      </div>
    )
  }

  // 세 번째 화면 - 실제 테스트 시작 화면
  return (
    <div className='min-h-screen'>
      {/* 헤더 */}
      <MainTopBar
        hasBackButton={true}
        leftSide={
          <div className='flex items-center gap-2'>
            <h1 className='text-header-title font-semibold text-text-header'>타입검사</h1>
          </div>
        }
        handleClickBackButton={() => navigate(-1)}
      />

      {/* 메인 콘텐츠 */}
      {hasPreviousTestResponse ? (
        <div className='flex-1 px-3 pb-8 pt-3'>
          <div className='bg-white rounded-2xl shadow-lg overflow-hidden h-[calc(100vh-200px)]'>
            <div className='flex flex-col h-full'>
              <div className='p-6 text-center flex flex-col justify-between h-full'>
                <h1 className='text-2xl font-bold text-gray-800 mb-4'>
                  이전 기록이 있습니다. <br />
                  다시 리포트를 생성할까요?
                </h1>

                {/* 하단 시작 버튼 */}
                <div className='p-6 flex flex-col gap-4'>
                  <button className='w-full bg-transparent border-none shadow-none text-gray-500'>
                    새로 답변하기{' '}
                  </button>
                  <WideButton
                    handleClick={() => {}} // FIXME: 리포트 생성 로직 추가
                    buttonText='리포트 생성하기 '
                    className='w-full bg-gradient-to-r from-amber-400 to-amber-600 hover:from-amber-500 hover:to-amber-700 text-white'
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className='flex-1 px-3 pb-8 pt-3'>
          <div className='bg-white rounded-2xl shadow-lg overflow-hidden h-[calc(100vh-200px)]'>
            {/* 테스트 내용 영역 */}
            <div className='flex flex-col h-full'>
              {/* 테스트 질문 영역 (현재는 빈 공간) */}
              <div className='flex-1 px-6 py-8 flex items-center justify-center'>
                <div className='text-center'>
                  <h1 className='text-amber-900 text-[20px] font-bold leading-relaxed text-nowrap'>
                    이 검사는
                    <br />
                    최초 1회만 진행될거야.
                    <br />
                    함께 시작해보자!
                  </h1>
                </div>
              </div>

              {/* 하단 시작 버튼 */}
              <div className='p-5'>
                <WideButton
                  handleClick={handleStartTest}
                  buttonText={
                    <div className=' flex items-center justify-center gap-2'>
                      <img src={qbeeImage} alt='main-character' className=' w-8 h-8' />
                      <p>검사 시작하기</p>
                    </div>
                  }
                  className='w-full bg-gradient-to-r from-amber-400 to-amber-600 hover:from-amber-500 hover:to-amber-700 text-white py-3'
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
